export const getImageSource = (mediaObj, checkMediaType = false) => {
  if (mediaObj.thumbnailKey && (!checkMediaType || (mediaObj?.type && mediaObj.type === 'VIDEO'))) {
    return mediaObj.thumbnailUrl;
  }
  return mediaObj.mediaUrl;
};

const loadingEntryData = [
  {
    id: 187,
    date: 'December 7, 2020 7:21:40 PM',
    title: 'Lorem ipsum dolor sit amet',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras consequat tellus at quam aliquam, ac iaculis erat sagittis. Mauris hendrerit faucibus aliquet.',
    authorId: 38,
    authorUserName: 'Teambuildr, Coach',
  },
  {
    id: 188,
    date: 'December 7, 2020 7:21:48 PM',
    title: 'orem ipsum',
    body: 'orem ipsum dolor sit amet, consectetur adipiscing elit.',
    authorUserName: 'Guillen, Elvis',
  },
  {
    id: 189,
    date: 'December 7, 2020 7:21:57 PM',
    title: 'Lorem ipsum dolor',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras consequat tellus at quam aliquam, ac iaculis erat sagittis. Mauris hendrerit faucibus aliquet.',
    authorUserName: 'Teambuildr, Coach',
  },
  {
    id: 190,
    date: 'December 7, 2020 7:22:05 PM',
    title: 'sit amet, consectetur adipiscing elit. Cras cons',
    body: 'sum dolor sit amet, consectetur adipiscing elit. Cras consequat tellus at quam aliquam, ac iaculis e',
    authorUserName: 'Teambuildr, Coach',
  },
  {
    id: 191,
    date: 'December 7, 2020 7:22:09 PM',
    title: 'Etiam laoreet',
    body: 'Mauris hendrerit faucibus aliquet. Etiam laoreet odio placerat venenatis faucibus. Nunc malesuada nunc ut nisi rutrum sagittis quis vel neque.',
    authorUserName: 'Guillen, Elvis',
  },
  {
    id: 192,
    date: 'December 8, 2020 7:12:05 PM',
    title: 'sit amet, consectetur adipiscing elit. Cras cons',
    body: 'sum dolor sit amet, consectetur adipiscing elit. Cras consequat tellus at quam aliquam, ac iaculis e',
    authorUserName: 'Teambuildr, Coach',
  },
  {
    id: 193,
    date: 'December 8, 2020 7:22:09 PM',
    title: 'Mauris hendrerit faucibus',
    body: 'Mauris hendrerit faucibus aliquet. Etiam laoreet odio placerat venenatis faucibus.',
    authorUserName: 'Guillen, Elvis',
  },
  {
    id: 194,
    date: 'December 9, 2020 7:12:05 PM',
    title: 'Lorem ipsum dolor',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    authorUserName: 'Teambuildr, Coach',
  },
  {
    id: 195,
    date: 'December 9, 2020 7:22:09 PM',
    title: 'Mauris',
    body: 'Mauris hendrerit faucibus aliquet. Etiam laoreet odio placerat venenatis faucibus. Mauris hendrerit faucibus aliquet. Etiam laoreet odio placerat venenatis faucibus.',
    authorUserName: 'Guillen, Elvis',
  },
  {
    id: 196,
    date: 'December 10, 2020 7:12:05 PM',
    title: 'Lorem ipsum dolor Lorem ipsum dolor',
    body: 'Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.',
    authorUserName: 'Teambuildr, Coach',
  },
];

export default loadingEntryData;
